import { render } from "./QualityControlDecision.vue?vue&type=template&id=0025dfa2"
import script from "./QualityControlDecision.vue?vue&type=script&lang=js"
export * from "./QualityControlDecision.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__